import React, {useCallback, useEffect, useRef, useState} from "react";
import {Form, Table} from "react-bootstrap";
import {useNavigate} from "react-router";
import AdminApi from "common/api";
import Pagination from "common/components/Pagination";
import {dateFormat} from "common/utils";

const PAGE_SIZE = 20;

export default function UserList() {
  const api = new AdminApi();
  const navigate = useNavigate();
  const currentPage = useRef(1);

  const [keyword, setKeyword] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const fetchUsers = useCallback((page = 1) => {
    api.getAdminUsers({
      keyword: searchKeyword,
      page,
      countPerPage: PAGE_SIZE,
    }).then((res) => {
      if (res?.result === "ok") {
        setUsers(res.users ?? []);
        setTotalCount(res.pageInfo?.totalItemCount ?? 0);
        currentPage.current = page;
      } else {
        setUsers([]);
        setTotalCount(0);
      }
    });
  }, [searchKeyword]);

  useEffect(() => {
    fetchUsers(1);
  }, [fetchUsers]);

  function onSearch(e) {
    e.preventDefault();
    setSearchKeyword(keyword.trim());
  }

  function onPageChange(page) {
    fetchUsers(page);
  }

  return (
    <div className="user-admin">
      <div className="user-list-header flex">
        <h1>사용자 관리</h1>
        <button type="button" className="blue-btn" onClick={() => navigate("/user/invite-ranking")}>
          초대 이벤트 집계
        </button>
      </div>

      <form className="user-search-form flex" onSubmit={onSearch}>
        <Form.Control
          type="text"
          placeholder="닉네임 또는 회원번호"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          style={{maxWidth: 320}}
        />
        <button type="submit" className="blue-btn">검색</button>
        {searchKeyword &&
          <button
            type="button"
            className="grey-btn"
            onClick={() => {
              setKeyword("");
              setSearchKeyword("");
            }}
          >
            초기화
          </button>
        }
      </form>

      <Table bordered className="basic-table user-list-table" style={{marginTop: 24}}>
        <thead>
          <tr>
            <th>회원번호</th>
            <th>닉네임</th>
            <th>로그인</th>
            <th>포인트</th>
            <th>간식</th>
            <th>누적 초대</th>
            <th>상태</th>
            <th>가입일</th>
          </tr>
        </thead>
        <tbody>
          {users.length > 0 ? users.map((user) => (
            <tr key={user.userNo}>
              <td>{user.userNo}</td>
              <td>
                <button
                  type="button"
                  className="user-link-btn"
                  onClick={() => navigate(`/user/${user.userNo}`)}
                >
                  {user.nickname || "-"}
                </button>
              </td>
              <td>{user.loginType || "-"}</td>
              <td>{user.point?.toLocaleString() ?? 0}</td>
              <td>{user.snackCount ?? 0}</td>
              <td>{user.inviteBuddyCount ?? 0}</td>
              <td>{user.status || "-"}</td>
              <td>{dateFormat(user.createdAt, true)}</td>
            </tr>
          )) : (
            <tr>
              <td colSpan={8} style={{textAlign: "center"}}>검색 결과가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </Table>

      {totalCount > 0 &&
        <Pagination
          total={totalCount}
          pageSize={PAGE_SIZE}
          page={currentPage.current}
          onPageChange={onPageChange}
        />
      }
    </div>
  );
}
